import Attributions from '@@views/Attributions'

export default Attributions
